import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(private http: HttpClient) { }

  getAllGroups() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getAllDiscountTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  getAllLimitationTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }
 
  getDiscountList() {
    return this.http.get<any>(`${environment.inventoryURl}discount`);
  }

  getSetDiscountConfig(status) {
    let params = new HttpParams();
    params = (status==undefined)? params: params.append('discountEnableStatus', status)
    return this.http.get<any>(`${environment.inventoryURl}Discount/DiscountConfiguration`, {params});
  }
 

  deleteDiscount(id) {
    return this.http.delete<any>(`${environment.inventoryURl}discount/${id}`)
      .toPromise()
      .then(res => res);
  }

  addDiscount(data) {
    return this.http.post<any>(`${environment.inventoryURl}discount`, data)
      .toPromise()
      .then(res => res);
  }

  updateDiscount(data) {
    return this.http.put<any>(`${environment.inventoryURl}discount`, data)
      .toPromise()
  }

  /**Additional Fees**/
  getSetAdditionalFeesConfig(status) {
    let params = new HttpParams();
    params = (status==undefined)? params: params.append('addFeesEnableStatus', status)
    return this.http.get<any>(`${environment.inventoryURl}Discount/AdditionalFeesConfiguration`, {params});
  }
    
}
